var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M280-80 120-240l160-160 56 58-62 62h406v-160h80v240H274l62 62-56 58Zm-80-440v-240h486l-62-62 56-58 160 160-160 160-56-58 62-62H280v160h-80Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }